module.exports = __webpack_public_path__ + "static/media/Blog.ecc2d051.png";